import React, { useEffect } from 'react'
import Additional from './Additional'
import Comment from './Comment'

const Javafullstack = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);

  return (
    <div>
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-8">
              {/* Blog Detail Start */}
              <div className="mb-5">
                <h1 className="mb-4">Why Java Fullstack Developer</h1>
                <p>Learn through our all-inclusive Corejava ,jst, spring with frontend Techonologies course syllabus with adequate practical experiences to develop the easy to manage Applicaitons. Our trainers are skilled and have the industry experience
                  to handle classes as per the student’s proficiency. We assist you for the assured placement after the successful course completion with valuable certification at Acrosys Technologies.</p>
                <p>
                  <b>Session 1: Introduction to Frontend</b>
                </p><p>Html, css</p>
                <b>Session 2: Java Script</b>
                <p>Datatypes,Conditional,loops,arrays,funcitons,Dom,exercises</p>
                <b>Session 3: Fundamentals of Java</b>
                <p>Datatypes, Statements, Blocks, identifiers, Keywords ,Literals,Prmitive Datatype, Variables, Type Casting and Operators</p>
                <b>Session 4: Control Structures </b>
                <p>Types of Control , Decision Control, Repitition Control</p>
                <b>Session 5: Input Fundamentals and Data Types</b>
                <p> Java inputs, scanner, java array,</p>
                <b>Session 6:OOPS</b>
                <p> Procedural vs OOPS,OOPS Introduction, Abstraction, Encapsulation,Polymorphism, Inheritance, class and ojects, method and behaviour, contructor vs method, java access modifier </p><b> Session 7: Filters </b>
                <p>Built-In Filters, Using Angular JS Filters Creating Custom Filters</p>
                <b>Session 8: inner class</b>
                <p>interfaces,exception Handling,Mutlithreading,Packages</p>
                <b> Session 9: JSP &amp; MY Sql Server</b>
                <p>jSP Fundamentals, My Sql server Fundamentals</p>
                <b> Session 10: JSTL</b>
                <p>Tags and Libraries</p>
                <b> Session 11: Java Beans </b>
                <p>Beans Class</p>
                <b>Session 12: Jstl crud</b>
                <p>Project based CRUD Exercises</p>
                <b>Session 13: hibernate</b>
                <p>ORM </p>
                <b>Session 14: Spring</b>
                <p>Introduction to Spring, Spring JDBC,Spring hibernate</p>
                <b>Session 15: Restful an Autowire</b>
                <p>Introduction to Spring Autowire,Restful service ,micro services</p>
                <b>Session 16:Junit</b>
                <p>Introduction to Junit, Testing</p>
                <b>Session 17: Angular</b>
                <p>Introduction to Angular and fundamentals</p>
                <b>Session 18: Projects</b>
                <p>Final Projects and Realtime Scenarios</p>
              </div>
              {/* Blog Detail End */}
              {/* Comment List Start */}
              <Comment/>
              {/* Comment Form End */}
            </div>
            {/* Sidebar Start */}
            <div className="col-lg-4">
              {/* Search Form Start */}
              <Additional/>
              {/* Plain Text End */}
            </div>
            {/* Sidebar End */}
          </div>
        </div>
      </div>

    </div>
  )
}

export default Javafullstack